module.exports = __webpack_public_path__ + "img/feedback5-2.caf714b6.jpg";